<template>
    <div class="accept-report">
        <accept-content :acceptCurrent="current">

        </accept-content>
    </div>
</template>
<script>
import acceptContent from '../components/acceptTerms/acceptContent.vue'
export default {
    components : {
        acceptContent
    },
    data(){
        return{
            acceptData : [
                {
                    name : 'responsibility',
                    nextRoute : 'eligibility',
                    title : this.$t("views.AcceptReport.acceptData.titles[0]"),
                    paragraphs : [
                        this.$t("views.AcceptReport.acceptData.paragraphs[0]"),
                        this.$t("views.AcceptReport.acceptData.paragraphs[1]"),
                        this.$t("views.AcceptReport.acceptData.paragraphs[2]")
                    ]
                },
                {
                    name : 'eligibility',
                    nextRoute : 'methodology',
                    title : this.$t("views.AcceptReport.acceptData.titles[1]"),
                    paragraphs : [
                        this.$t("views.AcceptReport.acceptData.paragraphs[3]"),
                        this.$t("views.AcceptReport.acceptData.paragraphs[4]"),
                        this.$t("views.AcceptReport.acceptData.paragraphs[5]")
                    ]
                },
                {
                    name : 'methodology',
                    nextRoute : '/report/graphic',
                    title : this.$t("views.AcceptReport.acceptData.titles[0]"),
                    paragraphs : [this.$t("views.AcceptReport.acceptData.paragraphs[6]")]
                }
            ],
            current : []
        }
    },
    async created(){
        let name = this.$route.params.id
        await this.alterAccept(name)
    },
    methods : {
        currentAccept(name){
            const currentAccept = this.acceptData.filter(accept => {
                return accept.name == name
            })
            return currentAccept
        },
        async alterAccept(name){
            let current = await this.currentAccept(name)
            this.current = current[0]
        }
    },
    async beforeRouteUpdate(to, from, next){
        let name = to.params.id
        await this.alterAccept(name)
        next()
    }
}
</script>
<style lang="scss" scoped>
    
</style>
